var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'button-status',
    _vm.classes,
    _vm.getStatusClass
  ]},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }